const serverHost = "https://extranet.brevistay.com/adex";
const staging = "https://adex.stage.sandbox.brevistay.com";
const preStaging_1 = "https://prestage-1-adex.ps.sandbox.brevistay.com";
const sessionManageTaskUrl = "https://prestage-3-session.ps.sandbox.brevistay.com";
const mergerIntegrationUrl = "https://adex.intgr.sandbox.brevistay.com";
const local = "http://localhost";


export const debug = 0 // CHANGE THIS TO 0 before deploying to live server
//(api,internalRoute)=> 0->(LIVE, LIVE) 1->(TEST,STAGING) 2->(TEST,LOCALHOST)

export const HOST = debug === 0 ? serverHost : debug === 1 ? staging : local

export const ADMINCHECKOUT = "https://admin.brevistay.com"
// debug == 0 ? extranetLive : debug === 1 ? extranetStaging  : extranetLocalHost;

export const HOTEL_API = HOST + "/wss/hotel";
export const SUPER_ADMIN_API = HOST + "/api/sa";
export const FINANCE = HOST + "/finance";
export const MARKETING = HOST + "/marketing"
export const USER_DATA = "user_data";
export const PAYMENT = HOST + "/payments"
export const SELECTED_HOTEL_ID = "selected_hotel_id";
export const SELECTED_HOTEL_NAME = "selected_hotel_name";
export const IS_FIRST_RENDER = "is_first_render";
export const SITE_IMG_BASE_URL = "https://images.brevistay.com/"
export const CM_LOGO = {
      STAAH:
        `${SITE_IMG_BASE_URL}extranet-new/STAAH.png`,
      AXISROOM:
        `${SITE_IMG_BASE_URL}extranet-new/AXISROOMSLOGO.jpg`,
      RESAVENUE:
        `${SITE_IMG_BASE_URL}extranet-new/RESAVENUELOGO.jpg`,
      EZEETECH:
        `${SITE_IMG_BASE_URL}extranet-new/EZEETECHLOGO.jpg`,
      RATEGAIN:
        `${SITE_IMG_BASE_URL}extranet-new/RateGainLogo.png`,
      STAYFLEXI:
        `${SITE_IMG_BASE_URL}extranet-new/StayFlexiLogo.png`,
      MINIHOTELMAN:
        `${SITE_IMG_BASE_URL}extranet-new/MiniHotelMan.png`
    };

export const API_RESPONSE = {
  SESSION_ERROR: "401",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR"
};
export const SESSION_ERROR = "session_error";

